var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var TwitchIcon = function (_a) {
    var color = _a.color, background = _a.background, _b = _a.width, width = _b === void 0 ? 40 : _b, _c = _a.height, height = _c === void 0 ? 40 : _c;
    return (_jsxs("svg", __assign({ width: width, height: height, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("path", { d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z", fill: color }, void 0), _jsx("path", { d: "M11.5003 9L10 13.0001V28.9985H15.4985V32H18.5005L21.4994 28.9985H25.9991L32 23.001V9H11.5003ZM13.4991 10.9988H30.0004V21.999L26.4993 25.4995H21L18.0019 28.4969V25.4995H13.4991V10.9988ZM18.9998 21.0003H21V15.001H18.9998V21.0003ZM24.4995 21.0003H26.4993V15.001H24.4995V21.0003Z", fill: background }, void 0)] }), void 0));
};
